import script from "./CollectionCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionCreated.vue?vue&type=script&lang=js"
export * from "./CollectionCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionCreated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-collection-card/CollectionCreated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66d886ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66d886ca', __exports__)) {
    api.reload('66d886ca', __exports__)
  }
  
}


export default __exports__